<template>
  <div>
    <!-- BEGIN: HTML Table Data -->
    <div class="intro-y box p-5 mt-5">
      <div class="flex flex-col sm:flex-row sm:items-end xl:items-start">
        <form id="tabulator-html-filter-form" class="xl:flex sm:mr-auto">
        </form>
        <div class="flex mt-5 sm:mt-0">
          <a
          href="javascript:;"
          data-toggle="modal"
          data-target="#new-order-modal"
          class="btn btn-primary shadow-md mr-2" @click="resetID"
          >New Process Group</a>
          <div class="dropdown w-1/2 sm:w-auto">
            <button
              class="dropdown-toggle btn btn-outline-secondary w-full sm:w-auto"
              aria-expanded="false"
            >
              <FileTextIcon class="w-4 h-4 mr-2" /> Export
              <ChevronDownIcon class="w-4 h-4 ml-auto sm:ml-2" />
            </button>
            <div class="dropdown-menu w-40">
              <div class="dropdown-menu__content box dark:bg-dark-1 p-2">
                <a
                  id="tabulator-export-csv"
                  href="javascript:;"
                  class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                  @click="onExportCsv"
                >
                  <FileTextIcon class="w-4 h-4 mr-2" /> Export CSV
                </a>
                <a
                  id="tabulator-export-json"
                  href="javascript:;"
                  class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                  @click="onExportJson"
                >
                  <FileTextIcon class="w-4 h-4 mr-2" /> Export JSON
                </a>
                <a
                  id="tabulator-export-xlsx"
                  href="javascript:;"
                  class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                  @click="onExportXlsx"
                >
                  <FileTextIcon class="w-4 h-4 mr-2" /> Export XLSX
                </a>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="overflow-x-auto scrollbar-hidden">
        <div
          id="tabulator"
          ref="tableRef"
          class="mt-5 table-report table-report--tabulator"
        ></div>
      </div>
    </div>
    <!-- END: HTML Table Data -->

    <!-- Add Department modal-->

    <div id="new-order-modal" class="modal" tabindex="-1" aria-hidden="true" data-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="font-medium text-base mr-auto">New Process Group</h2>
          </div>
          <div class="modal-body grid grid-cols-12 gap-4 gap-y-3">
            <div class="col-span-12">
              <label for="pos-form-1" class="form-label">Process Name</label>
              <TomSelect v-model="departmentForm.process" 
              :options="{
                placeholder: 'Select process',
                create: false,
              }" class="w-full" multiple>
                <option v-for="process in pagedata.processes" :key="process.id" :value="String(process.id)">{{
                  process.process_name }}</option>
              </TomSelect>
              <template v-if="validate.process.$error">
                    <div
                      v-for="(error, index) in validate.process.$errors"
                      :key="index"
                      class="text-theme-6 mt-2"
                    >
                      {{ error.$message }}
                    </div>
              </template>
            </div>
            <div class="col-span-12">
              <label for="pos-form-1" class="form-label">Last Process</label>
              <TomSelect v-model="departmentForm.last_process" 
              :options="{
                placeholder: 'Select last process',
                create: false,
              }" class="w-full" multiple>
                <option v-for="lst_process in pagedata.lst_processes" :key="lst_process.id" :value="String(lst_process.id)">{{
                  lst_process.process_name }}</option>
              </TomSelect>
              <template v-if="validate.last_process.$error">
                    <div v-for="(error, index) in validate.last_process.$errors"
                      :key="index"
                      class="text-theme-6 mt-2">
                      {{ error.$message }}
                    </div>
              </template>
            </div>
          </div>
          <div class="modal-footer text-right">
            <button
              type="button"
              data-dismiss="modal"
              class="btn btn-outline-secondary w-32 mr-1">
              Cancel
            </button>
            <button type="button" class="btn btn-primary w-32" @click="submitForm">
              Save Details
            </button>
            <!-- <button type="button" v-if="departmentForm.id != ''" class="btn btn-danger w-32 ml-1" @click="deleteItem">
              Delete
            </button> -->
          </div>
        </div>
      </div>
    </div>

    <div id="success-notification-content"
                class="toastify-content hidden flex">
                <CheckCircleIcon class="text-theme-9" />
                <div class="ml-4 mr-4">
                  <div class="font-medium">Details saved successfully!</div>
                  <div class="text-gray-600 mt-1">
                  </div>
                </div>
              </div>
              <!-- END: Success Notification Content -->
              <!-- BEGIN: Failed Notification Content -->
              <div
                id="failed-notification-content"
                class="toastify-content hidden flex">
                <XCircleIcon class="text-theme-6" />
                <div class="ml-4 mr-4">
                  <div class="font-medium">Something went wrong!</div>
                  <div class="text-gray-600 mt-1">
                    Please check the fileld form.
                  </div>
                </div>
              </div>
              <!-- END: Failed Notification Content -->
            </div>

</template>

<script>
/* eslint-disable */
import { defineComponent, ref, reactive, toRefs,onMounted } from 'vue'
import xlsx from 'xlsx'
import feather from 'feather-icons'
import Tabulator from 'tabulator-tables'
import Toastify from 'toastify-js'
import {
  required,
  minLength,
  maxLength,
  email,
  url,
  integer
} from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import axios from 'axios'
import VueRouter from 'vue-router'
import { useRouter, useRoute } from 'vue-router'
import { inject} from 'vue'
import { BASE_URL } from '@/constants/config.js'

export default defineComponent({
  setup() {
    const tableRef = ref()
    const tabulator = ref()
    const filter = reactive({
      field: 'department_name',
      type: 'like',
      value: ''
    })
    const swal = inject('$swal')
    const pagedata = reactive({
      processes: [],
      last_processes:[],
      managers: [],
      errors: [],
      error: ''
    })
    const departmentForm = reactive({
      process: [],
      last_process: [],
      id:''
    })

    const rules = {
      process: {
        required,
      },
      last_process: {
        required,
      },
    }
    const validate = useVuelidate(rules, toRefs(departmentForm))
    function getProcesses() {
        departmentForm.process = [];
        const params = {
          transaction_type: [1,3,4,5,6,7,8,9,10,11],
        }
        axios({
          url: 'api/master/dp_process',
          method: 'post',
          baseURL: BASE_URL,
          data: params,
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
          config: { headers: { 'Accept': 'application/json' } }
        }).then((res) => {
          pagedata.processes = res.data.items
        }).catch((err) => {
          pagedata.processes = []          
        })
    }
    function getLastProcesses() {
        departmentForm.last_process = [];
        const params = {
          transaction_type: [1,3,4,5,6,7,8,9,10,11],
        }
        axios({
          url: 'api/master/dp_process',
          method: 'post',
          baseURL: BASE_URL,
          data: params,
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
          config: { headers: { 'Accept': 'application/json' } }
        }).then((res) => {
          pagedata.lst_processes = res.data.items
        }).catch((err) => {
          pagedata.lst_processes = []          
        })
    }
    const initTabulator = () => {
      tabulator.value = new Tabulator(tableRef.value, {
        ajaxURL: BASE_URL + 'api/master/get_group_process',
        ajaxConfig:{
            method:"GET", //set request type to Position
            headers: {
                "Content-type": 'application/json; charset=utf-8', //set specific content type
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
        },
        ajaxFiltering: true,
        ajaxSorting: true,
        printAsHtml: true,
        printStyled: true,
        headerSort: true,
        // pagination: 'remote',
        // paginationSize: 20,
        // paginationSizeSelector: [10, 20, 30, 40],
        layout: 'fitColumns',
        responsiveLayout: 'collapse',
        placeholder: 'No matching records found',
        columns: [
          {
            formatter: 'responsiveCollapse',
            width: 40,
            minWidth: 30,
            hozAlign: 'center',
            resizable: false,
            headerSort: false
          },

          // For HTML table
          {
            title: 'Process Name',
            minWidth: 100,
            responsive: 0,
            field: 'process_list',
            vertAlign: 'middle',
            print: false,
            download: false,

          },
          {
            title: 'Last Process',
            minWidth: 100,
            responsive: 0,
            field: 'last_process_list',
            vertAlign: 'middle',
            hozAlign:'center',
            print: false,
            download: false,

          },
          {
            title: 'Status',
            minWidth: 100,
            field: 'active_status',
            hozAlign: 'center',
            vertAlign: 'middle',
            print: false,
            download: false,
            formatter(cell) {
              const btn_status =cash(`<div class="flex lg:justify-center ${
                cell.getData().active_status == '1'
                  ? 'text-theme-9'
                  : 'text-theme-6'
              }">
                <i data-feather="check-square" class="w-4 h-4 mr-2"></i> ${
                  cell.getData().active_status == '1'
                    ? 'Active'
                    : 'Inactive'
                }
              </div>`)
              cash(btn_status).on('click', function() {   
                const params = { id: btoa(cell.getData().group_id),                                
                                status:btoa(cell.getData().active_status),                                
                              } 
                var confirm_msg="";
                if(cell.getData().active_status=='1')
                    confirm_msg="Do you want to inactive the group process status?";
                else
                    confirm_msg="Do you want to active the group process status?";
                swal.fire({
                        title: 'Are you sure?',
                        text: confirm_msg,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'No'
                      }).then(result => {
                        if (result.isConfirmed || result.value) {
                          axios({
                            url: 'api/master/delete_process_group',
                            method: 'post',
                            baseURL: BASE_URL,
                            data: params,
                            headers: {
                              Authorization: 'Bearer ' + localStorage.getItem('token')
                            },
                            config: { headers: { Accept: 'application/json' } }
                          })
                            .then(res => {
                              swal.fire({
                                text: res.data.message,
                                icon: 'success',
                                buttonsStyling: false,
                                confirmButtonText: 'Ok, got it!',
                                heightAuto: false,
                                customClass: {
                                  confirmButton: 'btn btn-sm btn-primary btm-sm py-2'
                                }
                              })
                              initTabulator()
                            })
                            .catch(error => {
                              // Handle error if needed
                              // console.log(error.data)
                              if(error.response.status==422){
                                swal("Warning!", error.response.data.errors.message[0], "warning");
                              }
                              else {
                                swal.fire({
                                  text: error.response.data.errors,
                                  icon: 'error',
                                  buttonsStyling: false,
                                  confirmButtonText: 'Ok, got it!',
                                  heightAuto: false,
                                  customClass: {
                                    confirmButton: 'btn btn-sm btn-primary btm-sm py-2'
                                  }
                                })
                              }
                            })
                        }
                      })
              })
              return btn_status[0]
            }
          },
          {
            title: 'Actions',
            minWidth: 100,
            field: 'actions',
            responsive: 1,
            hozAlign: 'center',
            vertAlign: 'middle',
            print: false,
            download: false,
            formatter(cell) {
              const a = cash(`<div class="flex lg:justify-center items-center">
                <a class="flex items-center mr-3" href="javascript:;">
                  <i data-feather="check-square" class="w-4 h-4 mr-1"></i> Edit
                </a>

              </div>`)
              cash(a).on('click', function() {
                getDetails(cell.getData().group_id);
              })

              return a[0]
            }
          },

          // For print format
          {
            title: 'Process Name',
            field: 'process_list',
            visible: false,
            print: true,
            download: true
          },
          {
            title: 'Last Process',
            field: 'last_process_list',
            visible: false,
            print: true,
            download: true
          },
          {
            title: 'Status',
            field: 'active_Status',
            visible: false,
            print: true,
            download: true,
            accessorDownload(value) {
              return value == 1 ? 'Active' : 'Inactive'
            },
          }
        ],
        renderComplete() {
          feather.replace({
            'stroke-width': 1.5
          })
        }
      })
    }

    // Redraw table onresize
    const reInitOnResizeWindow = () => {
      window.addEventListener('resize', () => {
        tabulator.value.redraw()
        feather.replace({
          'stroke-width': 1.5
        })
      })
    }

    // Filter function
    const onFilter = () => {
      tabulator.value.setFilter(filter.field, filter.type, filter.value)
    }

    const getDetails = (group_id) => {
      // console.log(id);
      const params = {
      "id":  group_id,
      };

      let promise = axios({
        url: "api/master/get_single_process_group",
        method: "POST",
        params: params, 
        baseURL: BASE_URL,
        headers: { Authorization: "Bearer " + localStorage.getItem("token"),
 },
        config: { headers: { Accept: "application/json" } }
      });
      return promise
        .then(result => result.data)
        .then(data => {
          if (data && data.item && data.item[0]) {
            // console.log(data.item[0].process_list)
            if (data.item[0].process_list) {
              departmentForm.process = data.item[0].process_list
                .split(',')
                .map(value => String(value).trim())
                .filter(Boolean);
            } else {
              departmentForm.process = [];
            }
            if (data.item[0].last_process_list) {
              departmentForm.last_process = data.item[0].last_process_list
                .split(',')
                .map(value => String(value).trim())
                .filter(Boolean);
            } else {
              departmentForm.last_process = [];
            }
            departmentForm.id = data.item[0].group_id;
            cash('#new-order-modal').modal('show')
          }

        })
        .catch(_error => {

        });
    }

    const submitForm = () => {
      validate.value.$touch()
      if (validate.value.$invalid) {
        Toastify({
          node: cash('#failed-notification-content')
            .clone()
            .removeClass('hidden')[0],
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: 'top',
          position: 'right',
          stopOnFocus: true
        }).showToast()
      } else {
      const params = {
      "process_ids":  departmentForm.process,
      "last_process_ids":  departmentForm.last_process,
      "id" : departmentForm.id
      };
      let promise_url = '';
      if(departmentForm.id != '' && departmentForm.id != null){
        promise_url = "api/master/update_process_group";
      }else{
        promise_url = "api/master/add_new_process_group"
      }
      let promise = axios({
        url: promise_url,
        method: "POST",
        data: params,
        baseURL: BASE_URL,
        headers: { Authorization: "Bearer " + localStorage.getItem("token"),
 },
        config: { headers: { Accept: "application/json" } }
      });
      return promise
        .then(result => result.data)
        .then(data => {
          Toastify({
          node: cash('#success-notification-content')
            .clone()
            .removeClass('hidden')[0],
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: 'top',
          position: 'right',
          stopOnFocus: true
        }).showToast()

        cash('#new-order-modal').modal('hide')
        tabulator.value.setFilter(filter.field, filter.type, filter.value)
        departmentForm.process = '';
        departmentForm.last_process = '';
        departmentForm.id = '';
        validate.value.$reset()
        })
        .catch(_error => {
          // console.log(_error.response);
          if(_error.response.status==422){
            swal("Warning!", _error.response.data.errors.message[0], "warning");
          }
        });
      }
    }
    const resetID = () => {
      departmentForm.process = [];
      departmentForm.last_process = [];
      departmentForm.id = '';
    }

    const deleteItem = () => {
      // console.log(departmentForm.id);
    }

    // On reset filter
    const onResetFilter = () => {
      filter.field = 'process'
      filter.type = 'like'
      filter.value = ''
      onFilter()
    }

    // Export
    const onExportCsv = () => {
      tabulator.value.download('csv', 'data.csv')
    }

    const onExportJson = () => {
      tabulator.value.download('json', 'data.json')
    }

    const onExportXlsx = () => {
      const win = window
      win.XLSX = xlsx
      tabulator.value.download('xlsx', 'data.xlsx', {
        sheetName: 'Products'
      })
    }

    const onExportHtml = () => {
      tabulator.value.download('html', 'data.html', {
        style: true
      })
    }

    // Print
    const onPrint = () => {
      tabulator.value.print()
    }

    onMounted(() => {
      initTabulator()
      reInitOnResizeWindow()
      getProcesses();
      getLastProcesses();
    })


    return {
      tableRef,
      pagedata,
      filter,
      departmentForm,
      validate,
      submitForm,
      onFilter,
      deleteItem,
      onResetFilter,
      onExportCsv,
      onExportJson,
      onExportXlsx,
      onExportHtml,
      onPrint,
      resetID,
      getProcesses,
      getLastProcesses
    }
  }
})
</script>
